import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import * as Models from '../../../app/models/models';
import { AbstractEndpoints } from '../endpoints/endpoints.service.abstract';
import { AbstractServiceAdvertisement } from './advertisement.service.abstract';

export class MockServiceAdvertisements implements AbstractServiceAdvertisement {

    constructor(private endpoints: AbstractEndpoints, private http: HttpClient) {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    deleteAdvertisement(organizationId: string, advertisementId: string): Observable<Models.ResponseDeleteAdvertisement> {
        return of({
            isSuccess: true,
            isActive: false,
            data: []
        });
    }
}
